import { IGetTechnologiesAPIResponse } from "@/types/codeEditor.types";
import { HTTP_METHODS } from "../constants/HttpConstants";
import { sendRequestToInterviewWithCredential } from "../utils/request.utils";

// eslint-disable-next-line import/prefer-default-export
export const getTechnologiesAPI = () =>
  sendRequestToInterviewWithCredential<IGetTechnologiesAPIResponse>({
    method: HTTP_METHODS.GET,
    url: "/interviews/technology/list/",
  });
